export const ROLE_NAMES = {
  SUPER_ADMIN: "Super Admin",
  PLANNER: "WSM Planner",
  ENGINEERING_SUPERVISOR: "Engineering Supervisor",
  COSS: "COSS",
};

export const LEGACY_ROLE_ID_TO_NAME = {
  1: ROLE_NAMES.SUPER_ADMIN,
  2: ROLE_NAMES.PLANNER,
  3: ROLE_NAMES.ENGINEERING_SUPERVISOR,
  4: ROLE_NAMES.COSS,
};

export const roleNamesFromLegacyIds = (roleIds = []) => (
  roleIds
    .map((roleId) => LEGACY_ROLE_ID_TO_NAME[roleId] || roleId)
    .filter(Boolean)
);

export const hasRole = (user, roleName) => (
  user?.roles?.some((role) => role?.name === roleName) ?? false
);

export const hasAnyRole = (user, roleNames = []) => (
  user?.roles?.some((role) => roleNames.includes(role?.name)) ?? false
);
